import BaseSystemApi from 'api/BaseSystemApi';
import { env } from 'env';

export default class DecisionProcessingApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = env.REACT_APP_DE_API_URL;
}
